export default `
/* 全局属性 */
#nice {
  font-family: Optima, PingFangSC-regular, serif;
  font-size: 16px;
  color: rgb(0, 0, 0);
  line-height: 1.5em;
  padding: 0 2px;
}

/* 标题 */
#nice h1 {
  margin-top: 30px;
  margin-bottom: 15px;
  text-align: left;
}

#nice h1 .content {
  font-size: 24px;
  color: rgb(64, 184, 250);
  font-weight: bold;
  display: block;
}

#nice h2 {
  margin-top: 30px;
  margin-bottom: 15px;
  border-bottom: 4px solid rgb(64, 184, 250);
  position: relative;
  display: flex;
  align-items: center;
}

#nice h2 .prefix {
  display: none;
}

#nice h2 .content {
  font-size: 20px;
  color: rgb(64, 184, 250);
  font-weight: bold;
  display: flex;
  margin-left: 10px;
}

#nice h2 .suffix {
  display: block;
  flex: 1;
  margin-left: 10px;
  height: 10px;
  background-color: rgba(30, 144, 255, 0.1);
  border-top-left-radius: 20px;
  align-self: flex-end;
}
/* =========================================
   H3 标题：居中 + 前置发光代码图标
   ========================================= */

/* H3 容器：设置为 Flex 布局以便居中对齐 */
#nice h3 {
  margin-top: 30px;
  margin-bottom: 20px;
  display: flex;            /* 启用 Flexbox */
  justify-content: center;  /* 水平居中 */
  align-items: center;      /* 垂直居中 */
  text-align: center;       /* 确保文字本身也居中 */
  background: none;         /* 清除可能存在的背景 */
  padding: 0;
  border: none;             /* 清除边框 */
}

/* 前置图标容器 */
#nice h3 .prefix {
  display: none;
}

/* 标题文字样式 */
#nice h3 .content {
  font-size: 18px;
  font-weight: bold;
  color: #40B8FA; /* 使用你的主题色：灰蓝 */
  line-height: 1.4;
  margin: 0;      /* 清除默认边距 */
}

/* 清除可能存在的尾部元素 */
#nice h3 .suffix {
  display: none;
}

/* 段落 */
#nice p {
  font-size: 16px;
  color: rgb(43, 43, 43);
  line-height: 1.8em;
  letter-spacing: 0.02em;
  padding: 8px 0;
}

/* 加粗 */
#nice strong {
  color: rgb(64, 184, 250);
  font-weight: bold;
}

/* 列表 */
#nice ul {
  list-style-type: circle;
  padding-left: 25px;
  color: rgb(0, 0, 0);
  margin-top: 8px;
  margin-bottom: 8px;
}

#nice li section {
  margin-top: 5px;
  margin-bottom: 5px;
  font-weight: normal;
}

/* 引用 */
#nice blockquote {
  margin-top: 20px;
  margin-bottom: 20px;
  padding: 20px;
  border: 1px solid rgb(64, 184, 250);
  border-radius: 8px;
  background-color: rgb(255, 255, 255);
}

#nice .multiquote-1 {
  color: rgb(64, 184, 250);
  background-color: rgb(255, 255, 255);
  border-style: solid;
  border-width: 1px;
  border-color: rgb(64, 184, 250);
}
#nice .multiquote-1:first-child {
  margin-top: 0;
}
/* 分割线 */
#nice hr {
  margin: 10px 0;
  border-top: 2px solid rgb(64, 184, 250);
  border-bottom: none;
}

/* --- 链接 --- */
#nice a {
  text-decoration: none;
  color: #40B8FA;
  word-wrap: break-word;
  font-weight: bold;
  border-bottom: 1px solid #40B8FA;
}

/* --- 加粗 --- */
#nice strong {
  font-weight: bold;
  color: #40B8FA;
}

/* --- 斜体 --- */
#nice em {
  font-style: italic;
  color: #2b2b2b;
}

/* --- 加粗斜体 --- */
#nice em strong {
  font-weight: bold;
  color: #40B8FA;
}

/* --- 删除线 --- */
#nice del {
  font-style: italic;
  color: #888;
}

/* --- 分隔线 --- */
#nice hr {
  height: 1px;
  margin: 0;
  margin-top: 30px;
  margin-bottom: 10px;
  border: none;
  border-top: 2px dashed #40B8FA;
  opacity: 0.6;
}

/* --- 代码块 --- */
#nice pre {
  margin-top: 10px;
  margin-bottom: 10px;
}

#nice pre code {
  display: -webkit-box;
  font-family: Operator Mono, Consolas, Monaco, Menlo, monospace;
  border-radius: 4px;
  font-size: 12px;
  -webkit-overflow-scrolling: touch;
  background-color: #F5F5F5;
}

#nice pre code span {
  line-height: 1.8;
}

/* --- 行内代码 --- */
#nice p code,
#nice li code {
  font-size: 14px;
  word-wrap: break-word;
  padding: 2px 6px;
  border-radius: 3px;
  margin: 0 2px;
  color: #40B8FA;
  background-color: rgba(64, 184, 250, 0.1);
  font-family: Operator Mono, Consolas, Monaco, Menlo, monospace;
  word-break: break-all;
}

/* --- 图片 --- */
#nice img {
  display: block;
  margin: 0 auto;
  max-width: 100%;
  border-radius: 6px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

/* --- 图片容器 --- */
#nice figure {
  margin: 0;
  margin-top: 10px;
  margin-bottom: 10px;
}

/* --- 图片描述文字 --- */
#nice figcaption {
  margin-top: 5px;
  text-align: center;
  color: #888;
  font-size: 14px;
}

/* --- 表格容器 --- */
#nice .table-container {
  overflow-x: auto;
}

/* --- 表格 --- */
#nice table {
  display: table;
  text-align: left;
  width: 100%;
  border-collapse: collapse;
  margin: 20px 0;
}

#nice tbody {
  border: 0;
}

#nice table tr {
  border: 0;
  border-top: 1px solid #e0e0e0;
  background-color: white;
}

#nice table tr:nth-child(2n) {
  background-color: #F5FBFF !important;
}

#nice table tr th,
#nice table tr td {
  font-size: 16px;
  border: 1px solid #e0e0e0;
  padding: 10px;
  text-align: left;
}

#nice table tr th {
  font-weight: bold;
  background-color: #40B8FA;
  color: #ffffff;
}

/* 表格最小列宽 */
#nice table tr th:nth-of-type(n),
#nice table tr td:nth-of-type(n) {
  min-width: 85px;
}

#nice .footnote-word {
  color: #40B8FA;
  font-weight: bold;
}

#nice .footnote-ref {
  color: #40B8FA;
  font-weight: bold;
}

#nice .footnote-item {
  display: flex;
}

#nice .footnote-num {
  display: inline;
  width: 10%;
  background: none;
  font-size: 80%;
  opacity: 0.6;
  line-height: 1.8;
  font-family: Optima-Regular, Optima, PingFangSC-light, PingFangTC-light, 'PingFang SC', Cambria, Cochin, Georgia, Times, 'Times New Roman', serif;
}

#nice .footnote-item p {
  display: inline;
  font-size: 14px;
  width: 90%;
  padding: 0px;
  margin: 0;
  line-height: 1.8;
  color: #2b2b2b;
  word-break: break-all;
}

#nice sub, sup {
  line-height: 0;
}

#nice .footnotes-sep:before {
  content: "参考资料";
  display: block;
  color: #40B8FA;
  font-weight: bold;
}

/* --- 公式 --- */
#nice .block-equation {
  display: block;
  text-align: center;
  overflow: auto;
  display: block;
  -webkit-overflow-scrolling: touch;
}

#nice .block-equation svg {
  max-width: 300% !important;
  -webkit-overflow-scrolling: touch;
}

#nice .inline-equation {
}

#nice .inline-equation svg {
}

/* --- 图片流 --- */
#nice .imageflow-layer1 {
  margin-top: 1em;
  margin-bottom: 0.5em;
  white-space: normal;
  border: 0px none;
  padding: 0px;
  overflow: hidden;
}

#nice .imageflow-layer2 {
  white-space: nowrap;
  width: 100%;
  overflow-x: scroll;
}

#nice .imageflow-layer3 {
  display: inline-block;
  word-wrap: break-word;
  white-space: normal;
  vertical-align: middle;
  width: 100%;
}

#nice .imageflow-img {
  display: inline-block;
}

#nice .imageflow-caption {
  text-align: center;
  margin-top: 0px;
  padding-top: 0px;
  color: #888;
}

#nice .nice-suffix-juejin-container {
  margin-top: 20px !important;
}

#nice figure a {
  border: none;
}

#nice figure a img {
  margin: 0px;
}

#nice figure {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

/* --- 图片链接嵌套 --- */
#nice figure a {
  display: flex;
  justify-content: center;
  align-items: center;
}

#nice figure a + figcaption {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  margin-top: -35px;
  background: rgba(0, 0, 0, 0.7);
  color: white;
  line-height: 35px;
  z-index: 20;
}
.font-size-12 {
  font-size: 12px;
}
.font-size-14 {
  font-size: 14px;
}
.font-size-16 {
  font-size: 16px;
}
.font-size-18 {
  font-size: 18px;
}
.font-size-20 {
  font-size: 20px;
}

/* --- 特殊选项样式 (包裹 class="option-wrapper") --- */
#nice .option-wrapper ol {
  list-style: none;
  padding: 0;
  margin: 15px 0;
  display: flex;
  flex-direction: column;
  gap: 10px;
  counter-reset: option-counter;
}

#nice .option-wrapper ol li {
  display: flex;
  align-items: center;
  margin: 0;
  padding: 0;
}

#nice .option-wrapper ol li::before {
  counter-increment: option-counter;
  content: counter(option-counter, upper-alpha);
  display: inline-block;
  width: 24px;
  height: 24px;
  line-height: 24px;
  text-align: center;
  border-radius: 4px;
  color: #fff;
  font-weight: bold;
  font-size: 14px;
  margin-right: 8px;
  flex-shrink: 0;
}

/* 颜色循环: 红、橙、蓝、绿 */
#nice .option-wrapper ol li:nth-child(4n+1)::before { background-color: #FF5252; }
#nice .option-wrapper ol li:nth-child(4n+2)::before { background-color: #FF9800; }
#nice .option-wrapper ol li:nth-child(4n+3)::before { background-color: #2196F3; }
#nice .option-wrapper ol li:nth-child(4n+4)::before { background-color: #4CAF50; }

#nice .option-wrapper ol li section {
  margin: 0;
  padding: 0;
}
`;
